import { Route, Routes } from "react-router-dom";

import { PermissionEnum } from "@/utils/enums/PermissionEnum";

import { Restrict } from "@/components/Restrict";
import { DashboardFederalUnit } from "@/pages/federalunitesus/DashboardFederalUnit";
import { TripleViralReport } from "@/pages/federalunitesus/TripleViralReport";
import { ChronicCommunicableDiseasesDashboard } from "@/pages/federalunitesus/ChronicCommunicableDiseasesDashboard";
import { PregnancyDashboard } from "@/pages/federalunitesus/PregnancyDashboard";

export function FederalUnitEsusRoutes() {
	return (
		<Routes>
			<Route
				path="/dashboard-estadual/geral"
				element={
					<Restrict
						permissions={[PermissionEnum.ESUS_VIEW_STATE_REPORTS]}
						redirectIfNotAuthorized
					>
						<DashboardFederalUnit />
					</Restrict>
				}
			/>
			<Route
				path="/dashboard-estadual/triplice-viral"
				element={
					<Restrict
						permissions={[PermissionEnum.ESUS_VIEW_STATE_REPORTS]}
						redirectIfNotAuthorized
					>
						<TripleViralReport />
					</Restrict>
				}
			/>
			<Route
				path="/dashboard-estadual/vigilancia-em-saude"
				element={
					<Restrict
						permissions={[PermissionEnum.ESUS_VIEW_STATE_REPORTS]}
						redirectIfNotAuthorized
					>
						<ChronicCommunicableDiseasesDashboard />
					</Restrict>
				}
			/>
			<Route
				path="/dashboard-estadual/gestantes"
				element={
					<Restrict
						permissions={[PermissionEnum.ESUS_VIEW_STATE_REPORTS]}
						redirectIfNotAuthorized
					>
						<PregnancyDashboard />
					</Restrict>
				}
			/>
		</Routes>
	);
}
